"use client";

import * as ToastRadix from "@radix-ui/react-toast";
import { X as XIcon } from "lucide-react";
import { useEffect, useRef } from "react";
import { useToastContext } from "./ToastProvider";

interface ToastProps {
  description?: string;
  title: string;
  id: string;
}

export function Toast({ description, title, id }: ToastProps) {
  const { deleteToast } = useToastContext();

  useEffect(() => {
    callbackRef.current = deleteToast;
  }, [deleteToast]);

  const timeoutRef = useRef<number | null>(null);

  const callbackRef = useRef(deleteToast);

  useEffect(() => {
    timeoutRef.current = window.setTimeout(() => callbackRef.current(id), 4000);

    return () => window.clearTimeout(timeoutRef.current || 0);
  }, [id]);

  return (
    <div>
      <ToastRadix.Root className="bg-white rounded-md shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut">
        <ToastRadix.Title className="[grid-area:_title] mb-[5px] font-bold text-slate12 text-[15px]">
          {title}
        </ToastRadix.Title>
        {description && (
          <ToastRadix.Description className="[grid-area:_description] m-0 text-slate11 text-[13px] leading-[1.3]">
            {description}
          </ToastRadix.Description>
        )}
        <ToastRadix.Action
          className="[grid-area:_action]"
          asChild
          altText="Close"
        >
          <button className="p-2 ">
            <XIcon className="h-6 w-6 hover:stroke-neutral-500 transition-colors" />
          </button>
        </ToastRadix.Action>
      </ToastRadix.Root>
    </div>
  );
}
